// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const ConnectToExistingPlanModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-connecttoexistingplanmodalcontainer" */ "./ConnectToExistingPlanModalContainer")).then((bundle)=>{
        return {
            default: bundle.ConnectToExistingPlanModalContainer
        };
    });
export const LazyConnectToExistingPlanModalContainer = /*#__PURE__*/ lazy(ConnectToExistingPlanModalContainerLazyLoader);
